// extracted by mini-css-extract-plugin
module.exports = {"container":"landingPage_container__13sDG","video":"landingPage_video__ecc7X","h1":"landingPage_h1__3zxUK","linkHome":"landingPage_linkHome__3h7bP"};